import React, { useMemo } from 'react';
import { MagnifyingGlassIcon } from '../Icons/Icons';
import { useTranslate } from 'piral-translate';
import './spotlight-trigger.css';

export const SpotlightTrigger: React.FC = () => {
  const translate = useTranslate();
  const isMac = useMemo(() => /Mac|iPhone|iPad|iPod/.test(navigator.userAgent), []);

  const openSpotlight = () => {
    const event = new KeyboardEvent('keydown', {
      key: 'k',
      ctrlKey: !isMac,
      metaKey: isMac,
      bubbles: true,
    });
    document.dispatchEvent(event);
  };

  return (
    <button className="neo-spotlight-trigger" onClick={openSpotlight} type="button">
      <MagnifyingGlassIcon className="neo-spotlight-trigger-icon" />
      <span className="neo-spotlight-trigger-text">{translate('search-pilets')}</span>
      <span className="neo-spotlight-trigger-shortcut">{isMac ? '⌘' : translate('shortcut-ctrl')}+K</span>
    </button>
  );
};
